import React, { useContext, useEffect, useState } from 'react';
import {
  Input,
  Table,
  Row,
  Col,
  Card,
  Button,
  Switch,
  Modal
} from 'antd';
import { PageHeader } from '@ant-design/pro-components';
import Exporticon from '../../components/icons/Exporticon/Exporticon';
import { SorterResult, TablePaginationConfig } from 'antd/lib/table/interface';
import { pagination, sortByParams } from 'types';
import { observer } from 'mobx-react';
import { rootContext } from 'stores';
import { RouteConfigs } from 'config/routes';
import './Report.scss';
import { sortOrderType } from 'common/utils';
import { useNavigate } from 'react-router-dom';
import Submodels from 'components/Submodels/Submodels';
import PartVersion from 'components/PartVersion';
import { useDebounceState } from 'hooks/useDebounce.hook';
import dayjs from 'dayjs';
import { getExportReport, getUserActivityList } from 'services/report';

export type IFilterType = {
  [key: string]: string | null;
};

const Report: React.FC = observer(() => {
  const {
    UsersActivityReport: {
      state,
      state: { data, ui },
      setState,
      getUserReports,
      toogleSwitch
    }
  } = useContext(rootContext);
  const navigate = useNavigate();

  const [search, deSearch, setSearch] = useDebounceState('', 500);
  const [alerTypeModel, setAlertTypeModel] = useState(false);
  const [alerTypeData, setAlertTypeData] = useState([]);
  const [activityList, setActivityList] = useState([]);
  const [alerTypeId, setAlertTypeId] = useState('');

  const getReport = () => {
    //todo check
  };
  
  useEffect(() => {
    getUserReports({ ...data.getUserReportsParams, search: deSearch })
  }, [getUserReports, data.getUserReportsParams, deSearch]);

  const getActivityList = async (id: any) => {
    const data = await getUserActivityList(id);
    setActivityList(data.data.data);
  };

  useEffect(() => {
    if (alerTypeId) {
      getActivityList(alerTypeId);
    }
  }, [alerTypeId]);

  const tableOnChange = (
    pagination: TablePaginationConfig,
    _: any,
    sort: any
  ) => {
    sort = sort as SorterResult<any>;
    const sortField = sort.columnKey as string;
    const sortBy = sort.order && sortOrderType(sort.order);
    const limit = pagination.pageSize || data.getUserReportsParams.limit;
    const offset = ((pagination?.current || 1) - 1) * limit;

    let getUserReportsParams: sortByParams & pagination = {
      limit,
      offset
    };

    if (sortField && sortBy) {
      getUserReportsParams = { ...getUserReportsParams, sortBy, sortField };
    }

    setState({
      data: {
        ...state.data,
        getUserReportsParams
      }
    });
  };
  const downloadCsv = async () => {
    const { data } = await getExportReport();
    if (data) {
      let csvContent = atob(data.data);
      var blob = new Blob([csvContent], {
        type: 'data:application/octet-stream;base64'
      });
      var url = window.URL.createObjectURL(blob);
      const link: any = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.setAttribute('download', `report.csv`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  };
  return (
    <div className="PartsStyles report">
      <div className="cardWrapeer">
        <Submodels />
        <PartVersion />
        <Card>
          <PageHeader>
            <Row justify="space-between">
              <Col>
                <Input.Search
                  className="search_input_control"
                  loading={ui.isUserReportLoading}
                  allowClear
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  placeholder="Search"
                />
              </Col>
              <Col>
                <Button
                  type="primary"
                  icon={<Exporticon size="15" color="#EF5366" />}
                  className="icon-btn reverse primary_btn export-data"
                  onClick={downloadCsv}
                >
                  Export Data
                </Button>
              </Col>
            </Row>
          </PageHeader>
          <Table
            rowKey="id"
            className="Table_block_main"
            loading={ui.isUserReportLoading}
            dataSource={data.userReports}
            pagination={{
              defaultCurrent: 1,
              defaultPageSize: data.getUserReportsParams.limit,
              total: data.total || 0,
              showSizeChanger: true,
              pageSizeOptions: ['10', '15', '20']
            }}
            onChange={(pagination, _, sort) =>
              tableOnChange(pagination, _, sort)
            }
            columns={[
              {
                dataIndex: 'userData.username',
                title: 'User Name',
                align: 'center',
                key: 'username'
              },
              {
                dataIndex: 'createdAt',
                title: 'Date Time',
                key: 'createdAt',

                render: value => dayjs(value).format('DD-MM-YYYY HH:mm A')
              },
              {
                dataIndex: 'alert_type',
                title: 'Alert Type',
                key: 'alert_type',
                render: (_, data) => {
                  return (
                    <div>
                      <span>
                        {`${data.alert_type[0]}...`}
                        <span
                          style={{
                            cursor: 'pointer',
                            color: '#00FFFF'
                          }}
                          onClick={() => {
                            setAlertTypeModel(true);
                            setAlertTypeData(data.alert_type);
                            setAlertTypeId(data.id);
                          }}
                        >
                          view all
                        </span>
                      </span>
                    </div>
                  );
                }
              },
              {
                dataIndex: 'userData.id',
                title: 'Redirect To Profile',
                key: 'id',
                render: (_, data) => {
                  return (
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={() => navigate(RouteConfigs.userDetail.getPath(data.user_id))}
                      >
                      Go to profile
                    </div>
                  );
                }
              },
              {
                dataIndex: 'brandData.brand',
                title: 'Car Print',
                align: 'center',
                key: 'brand'
              },
              {
                title: 'Review Alert',
                align: 'center',
                dataIndex: 'is_checked',
                key: 'is_checked',
                render: (value: boolean, report) => (
                  <Switch
                    checked={value}
                    onChange={async (v, e) => {
                      await toogleSwitch({
                        id: report.id,
                        is_checked: v
                      });
                      getReport();
                      e.stopPropagation();
                    }}
                  />
                )
              }
            ]}
          ></Table>
          <Modal
            visible={alerTypeModel}
            className="modelContent"
            onCancel={() => setAlertTypeModel(false)}
            footer={false}
            title="Alert Type"
            afterClose={() => {
              setAlertTypeData([]);
              setActivityList([]);
            }}
          >
            <ul className="dataUl">
              {activityList?.map((item: any) => (
                <li style={{ padding: '3px 2px' }}>
                  {`${dayjs
                    .unix(item.opened_at / 1000)
                    .format('ddd MMM D h:mm A')}`}{' '}
                  <b>opened</b>{' '}
                  {`${item.viewedPart.model} Model of ${dayjs
                    .unix(item.opened_at / 1000)
                    .format('YYYY')}`}
                </li>
              ))}
            </ul>
            <ul>
              {alerTypeData.map(type => (
                <li style={{ marginLeft: '35px' }}>{type}</li>
              ))}
            </ul>
          </Modal>
        </Card>
      </div>
    </div>
  );
});

export default Report;
